import { render, staticRenderFns } from "./MoviesView.vue?vue&type=template&id=89a13e18&"
import script from "./MoviesView.vue?vue&type=script&lang=js&"
export * from "./MoviesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports